import React, { useEffect, useState } from "react";
import { StyledH2, StyledTextInput } from "@aureskonnect/react-ui";
import Switch from "react-switch";
import { t } from "i18next";
import { AvGroup, AvForm } from "availity-reactstrap-validation";
import classnames from "classnames";
import { numberMatchWord } from "@constants/index";
import { useSnapshot } from "valtio";
import {
    store,
    setIsValidationPeriodToTake,
    setOptionComposite,
    setOrders,
} from "../../store";
import { ErrorMessage } from "./Orders";

function OrdersDiffer({ selectedRows }: any) {
    const { isValidationPeriodToTake } = useSnapshot(store);

    const getInitialDeferredOrder = () => {
        if (!selectedRows?.length || !selectedRows[0]?.["composite Products"]) {
            return { isDeferredOrders: false, maximumPeriod: 0 };
        }

        const compositeProducts = selectedRows[0]["composite Products"];
        const cmdDiffere = compositeProducts.CMD_DIFFERE;

        return {
            isDeferredOrders:
                cmdDiffere !== undefined ? cmdDiffere.ACITVE === true : false,
            maximumPeriod:
                cmdDiffere !== undefined ? Number(cmdDiffere.NBR_JOUR) || 0 : 0,
        };
    };

    const [deferredOrder, setDeferredOrder] = useState(getInitialDeferredOrder);

    useEffect(() => {
        const currentComposite =
            selectedRows?.length && selectedRows[0]?.["composite Products"]
                ? selectedRows[0]["composite Products"]
                : { REGLEGRATUITE: {} };

        const composite: any = {
            REGLEGRATUITE: currentComposite.REGLEGRATUITE || {},
            CMD_DIFFERE: {
                ACITVE: deferredOrder.isDeferredOrders,
                NBR_JOUR: deferredOrder.maximumPeriod.toString(),
            },
        };

        setOptionComposite(composite);
        setOrders({
            isDeferredOrders: deferredOrder.isDeferredOrders,
            maximumPeriod: deferredOrder.maximumPeriod,
        });
    }, [deferredOrder, selectedRows]);

    const handleSwitchChange = (checked: boolean) => {
        setDeferredOrder((prev) => ({
            ...prev,
            isDeferredOrders: checked,
            maximumPeriod: checked ? prev.maximumPeriod : 0,
        }));
    };

    const handleMaximumPeriodChange = (value: string) => {
        if (value.match(numberMatchWord) || value === "0") {
            const numericValue = parseInt(value, 10);
            setDeferredOrder((prev) => ({
                ...prev,
                maximumPeriod: numericValue,
            }));
            setIsValidationPeriodToTake(false);
        } else {
            setIsValidationPeriodToTake(true);
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <StyledH2
                    style={{
                        font: "normal normal 400 20px/27px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className="ml-5 pt-3"
                >
                    {t("Deferred orders")}
                </StyledH2>

                <Switch
                    className="cac_icn_deferredOrders mr-4"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={deferredOrder.isDeferredOrders}
                    onChange={handleSwitchChange}
                />
            </div>

            <AvForm>
                <AvGroup
                    className={classnames(
                        "d-flex justify-content-align mt-3 ml-3 px-5",
                        {
                            "not-allowed-icon__clz": !deferredOrder.isDeferredOrders,
                        }
                    )}
                >
                    <span
                        className=" ml-5"
                        style={{
                            font: "normal normal 400 15px/24px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                            width: "329px",
                        }}
                    >
                        {t("Maximum withdrawal period to respect (in days)")}
                    </span>

                    <StyledTextInput
                        min="0"
                        max="99"
                        id="commande"
                        name="commande"
                        type="number"
                        onKeyPress={(event: any) => {
                            const inputValue = event.key;
                            if (!/[0-9]/.test(inputValue)) {
                                event.preventDefault();
                            }

                            const combinedValue =
                                event.currentTarget.value + inputValue;
                            const numericValue = parseInt(combinedValue, 10);
                            if (numericValue > 99) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(e: any) =>
                            handleMaximumPeriodChange(e.target.value)
                        }
                        className={classnames(
                            "mb-2 mr-2 cac_inp_minimumWithdrawalTime",
                            {
                                input__clz: isValidationPeriodToTake,
                            }
                        )}
                        value={deferredOrder.maximumPeriod.toString()}
                        style={{
                            width: "110px",
                            height: "40px",
                        }}
                        disabled={!deferredOrder.isDeferredOrders}
                    />

                    {isValidationPeriodToTake && (
                        <ErrorMessage
                            message={t("Please insert a period")}
                            fontSize="80"
                        />
                    )}
                </AvGroup>
                <div className="mt-1 ml-3 px-5">
                    <span
                        className="not-allowed-icon__clz  ml-5 "
                        style={{
                            font: "normal normal 400 15px/24px Segoe UI",
                            color: "#000000",
                            opacity: "1",
                            width: "329px",
                        }}
                    >
                        {t(
                            "If the value entered is 5 days, then the end customer has the possibility of ordering up to D+5 from the date of order taking."
                        )}
                    </span>{" "}
                </div>
            </AvForm>
        </>
    );
}

export default OrdersDiffer;
